var mobileTooltipHandler = function () {
    $('.cta-button.tooltip').on('click', function(e) {
      var winWidth = window.innerWidth;
      if(winWidth < 1200) {
        e.preventDefault();
        $(this).children('.tooltiptext').addClass('active');
        var dest = $(this).parent('.cta-button__link').attr('href');
        
        setTimeout(function(){ window.location = dest;}, 1000);
      }
  });
};

(function() {
  mobileTooltipHandler();
}(jQuery));